import axios from 'axios'

var refreshTimer = false;

const getDefaultState = () => {
    return {
        fqd: {
            queue: [],
            currentId: false,
        },
    }
  }

export const state = getDefaultState()
export const getters = {
    getFQDQueue(state) { return state.fqd.queue },
    testFinished(state) {
        if(!state.fqd.currentId) return false;
        return state.fqd.queue.find(e => e.fileId == state.fqd.currentId).completed == "1";
    }
}

export const mutations = {
    setFQDQueue(state, data) {
        state.fqd.queue = [];
        data.forEach((x) => {
            state.fqd.queue.push(x);
        })
    },
    setCurrentId(state, data) {
        state.fqd.currentId = data;
    }
}

export const actions = {
    // LoadInitialData has been migrated to NodeJS server
    LoadInitialData(state) {
        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_SERVER + "/fqd/queue", { headers: { Authorization: 'Berear '+state.getters.accessToken} })
            .then((r) => {
                if(r.status == 201) {
                    if(r.data.filter(e => e.completed == 0).length == 0) {
                        //clearInterval(refreshTimer);
                    }
                    state.commit("setFQDQueue", r.data.slice(0,5));
                    resolve(true);
                }
            })            
        })
    },
    DownloadTXTfromFQD(state, id) {
        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_SERVER + "/fqd/" + id + "/text/", { headers: { Authorization: 'Berear '+state.getters.accessToken} })
            .then((r) => {
                resolve(r.data);
            })
        })
    },
    UploadFQD(state, data) {
        var file = data[0];
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_SERVER + "/fqd/upload", file, { headers: { Authorization: 'Berear '+state.getters.accessToken} })
            .then((r) => {
                if(r.status == 201) {
                    state.dispatch("LoadInitialData");
                    const testid = r.data;
                    state.commit("setCurrentId", testid.id);
                    refreshTimer = setInterval(() => {
                        state.dispatch("LoadInitialData");
                        if(state.getters.testFinished) {
                            resolve(testid.id);
                        }
                    }, 5000)
                }
                else
                reject(false);
            })
        })
    }
}


export default {
    namespaced: false,
    state,
    getters,
    actions, 
    mutations
  }